<template>
  <UiCheckbox
    v-for="item of tourTypesAvailable"
    :key="item.value"
    :label="item.label"
    :isChecked="isChecked(item.value)"
    class="filter-format__checkbox"
    @inputValue="toggleCheckbox(item.value)"
  >
    <template #hint>
      {{ item.description }}
    </template>
  </UiCheckbox>
</template>

<script setup lang="ts">
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { useTourFiltersStore } from '@/entities/filter/store/tour';
  import type { TFormatTourValue } from '../../types/format';
  import { useFormatTypes } from '../../composables/useFormatTypes';
  import { locales } from '../../i18n';

  const filtersStore = useTourFiltersStore();

  const { tourTypesAvailable } = useFormatTypes(locales.ru);

  function isChecked(value: TFormatTourValue) {
    return filtersStore.state.tourFormat.includes(value);
  }

  function toggleCheckbox(value: TFormatTourValue) {
    if (isChecked(value)) {
      filtersStore.state.tourFormat = filtersStore.state.tourFormat.filter((item) => item !== value);
    } else {
      filtersStore.state.tourFormat.push(value);
    }
  }
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography' as typography;

  .filter-format__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;

    :deep(.checkbox__label) {
      @include typography.base-400-400-regular;
    }
  }
</style>
